export const ERRORS = {
    NO_PEOPLE: 'Please enter valid people',
    ENTER_VALUE: 'Enter Value',
    ENTER_AMOUNT: 'Please enter Amount',
    MIN_AMOUNT: 'Minimum Amount $0.01', 
    GRATER_RATE_VALUE: 'Value should be greater than ',
    TOTAL_AMOUNT: 'Maximum Amount $150000',
    HIGHER_RATE: 'Cannot be less than higher rate'
}